var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"iconfont icon-shangyiyehoutuifanhui-yuankuang",on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("回退")])])}
var staticRenderFns = []

export { render, staticRenderFns }